
    import './styles.scoped.css';
    export default {
  "axis": "awsui_axis_f0fot_j3xvc_1",
  "vertical-marker": "awsui_vertical-marker_f0fot_j3xvc_2",
  "axis--emphasized": "awsui_axis--emphasized_f0fot_j3xvc_7",
  "axis-label": "awsui_axis-label_f0fot_j3xvc_11",
  "axis-label--x": "awsui_axis-label--x_f0fot_j3xvc_16",
  "axis-label--y": "awsui_axis-label--y_f0fot_j3xvc_17",
  "grid": "awsui_grid_f0fot_j3xvc_21",
  "ticks__line": "awsui_ticks__line_f0fot_j3xvc_26",
  "ticks__text": "awsui_ticks__text_f0fot_j3xvc_31",
  "ticks--y": "awsui_ticks--y_f0fot_j3xvc_36",
  "ticks--x": "awsui_ticks--x_f0fot_j3xvc_37",
  "ticks--bottom": "awsui_ticks--bottom_f0fot_j3xvc_41",
  "labels-left": "awsui_labels-left_f0fot_j3xvc_46",
  "ticks": "awsui_ticks_f0fot_j3xvc_26",
  "labels-left__label": "awsui_labels-left__label_f0fot_j3xvc_61",
  "labels-left--hidden": "awsui_labels-left--hidden_f0fot_j3xvc_65",
  "labels-bottom": "awsui_labels-bottom_f0fot_j3xvc_73",
  "vertical-marker-circle": "awsui_vertical-marker-circle_f0fot_j3xvc_84",
  "vertical-marker-circle-active": "awsui_vertical-marker-circle-active_f0fot_j3xvc_90",
  "focus-outline": "awsui_focus-outline_f0fot_j3xvc_95",
  "filter-container": "awsui_filter-container_f0fot_j3xvc_103"
};
  